// TODO move translations to Dynolang/sanity

export interface DynomiteError {
    coord: string;
    data: string[];
    path: string;
    tag: string;
}

const translations: Map<string, (err: DynomiteError) => string> = new Map<
    string,
    (err: DynomiteError) => string
>();

// Shift Type
translations.set('CoreStartTimeBeforeShiftStartTime', (err: DynomiteError) => {
    const shift_code = err.data[0];
    const core_start = err.data[1];
    return `Vaktkode ${shift_code} - 'Kjernetid start klokken' ${core_start} 
    er før vakt 'Starter' {shift_start}. Sett 'Kjernetid start klokken' til 
    et tidspunkt som er likt eller etter vaktstarti Avdelingsoppsett.`;
});

translations.set('CoreTimeLongerThanOverallTime', (err: DynomiteError) => {
    const shift_code = err.data[0];
    return `Vaktkode ${shift_code} - Maks. lengde på vakten kan ikke være kortere enn lengden på kjernetid. 
    Sett lengden på vakten til et tidspunkt som er likt eller etter kjernetid slutt. Endre i Avdelingsoppsett.`;
});

translations.set('CoreEndTimeAfterShiftEndTime', (err: DynomiteError) => {
    const shift_code = err.data[0];
    const core_end = err.data[1];
    const shift_end = err.data[2];
    return `Vaktkode ${shift_code} - 'Kjernetid slutt klokken' ${core_end} er etter 'Slutter' ${shift_end}. 
    Sett 'Kjernetid slutt klokken' til et tidspunkt som er før 'Slutter' i Avdelingsoppsett.`;
});

translations.set('ShiftDurationAtMostOneDay', (err: DynomiteError) => {
    const shift_code = err.data[0];
    return `Vaktkode ${shift_code} - Sett vaktlengde til kortere enn 24 timer i Avdelingsoppsett.`;
});

translations.set('ShiftStartTimeOutsideTheBoundary', (err: DynomiteError) => {
    const shift_code = err.data[0];
    const day_name = err.data[1];
    const time_range = err.data[2];
    return `Starttid for vakt <strong>${shift_code}</strong>på <strong>${day_name}</strong> er 
    ikke innenfor tillatt tidsgrense ${time_range}. Endre i Avdelingsoppsett`;
});

translations.set('ShiftEndTimeOutsideTheBoundary', (err: DynomiteError) => {
    const shift_code = err.data[0];
    const day_name = err.data[1];
    const time_range = err.data[2];
    return `Sluttid for vakt ${shift_code} på ${day_name} er ikke innenfor tillatt 
    tidsgrense ${time_range}. Endre i Avdelingsoppsett`;
});

translations.set('BreakMinutesNotWithinRange', (err: DynomiteError) => {
    const code = err.data[0];
    return `Vakttype med kode ${code} har passiv tid satt til ugyldig verdi. Gyldige verdier er fra 0 til vaktlengde.`;
});

// Employee
translations.set('InvalidWorkingWeekMinutes', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} har ugyldig uketimer. Tillat verdi er mellom 0 og 120`;
});

translations.set('InvalidVacancyRate', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} - Stillingsprosent kan ikke være 0`;
});

translations.set('F3EligibleSetForOnlyWeekender', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} kan ikke ikke tildeles F3 når han/hun kun jobber helg`;
});

translations.set('PositionAndRestPositionNotAligned', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} har en inkonsistens mellom stillings-id og stillinginformasjon. 
    Dette skyldes en intern feil. Vennligst kontakt kundeservice.`;
});

translations.set(
    'AtleastOneShiftEnabledForEnabledEmployee',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} har ingen vaktkoder. Tildel den ansatte vaktkoder i ansattlisten`;
    },
);

translations.set('ZeroMaxSequence', (err: DynomiteError) => {
    const employee = err.data[0];
    return `For ansatt ${employee}, sett maks antall vakter på rad i ansattlisten til å være høyere enn 0.`;
});

translations.set('DayShiftsAndDayMaxSeqNotAligned', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} har en ugyldig kombinasjon av vaktkoder og 'Maks. dagvakter på rad'. 
    Verdi må være større enn 0 dersom den ansatte kan jobbe dag, og 0 hvis ikke.`;
});

translations.set(
    'DayShiftMaxSeqLowerThanDayShiftMinSeq',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const min = err.data[1];
        const max = err.data[2];
        return `Ansatt ${employee} - Ansattes minimumssekvens av dagvakt (${min}) er høyere enn hans maksimale 
    sekvens av dagvakt (${max}). Sett 'Min. dagvakter på rad' til et lavere tall enn 'Maks dagvakter på rad', 
    eller 'Maks. dagvakter på rad' til en høyere verdi.`;
    },
);

translations.set(
    'EveningShiftsAndEveningMaxSeqNotAligned',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} har en ugyldig kombinasjon av vaktkoder og 'Maks. kveldsvakter på rad'. 
    Verdi må være større enn 0 dersom den ansatte kan jobbe kveld, og 0 hvis ikke.`;
    },
);

translations.set(
    'EveningShiftMaxSeqLowerThanEveningShiftMinSeq',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const min = err.data[1];
        const max = err.data[2];
        return `Ansatt ${employee} - Ansattes minimumssekvens av kveldsvakt (${min}) er høyere enn hans maksimale 
    sekvens av kveldsvakt (${max}). Sett 'Min. kveldsvakter på rad' til et lavere tall enn 'Maks kveldsvakter på rad', 
    eller 'Maks. kveldsvakter på rad' til en høyere verdi.`;
    },
);

translations.set('LongShiftsAndLongMaxSeqNotAligned', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} har en ugyldig kombinasjon av vaktkoder og 'Maks. langvakter/mellomvakter på rad'. 
    Verdi må være større enn 0 dersom den ansatte kan jobbe langvakter/mellomvakter, og 0 hvis ikke.`;
});

translations.set(
    'LongShiftMaxSeqLowerThanLongShiftMinSeq',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const min = err.data[1];
        const max = err.data[2];
        return `Ansatt ${employee} - Ansattes minimumssekvens av langvakter/mellomvakter (${min}) er høyere enn hans maksimale 
    sekvens av langvakter/mellomvakter (${max}). Sett 'Min. langvakter/mellomvakter på rad' til et lavere tall enn 
    'Maks langvakter/mellomvakter på rad', eller 'Maks. langvakter/mellomvakter på rad' til en høyere verdi.`;
    },
);

translations.set(
    'NightShiftsAndNightMaxSeqNotAligned',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} har en ugyldig kombinasjon av vaktkoder og 'Maks. nattevakter på rad'. 
    Verdi må være større enn 0 dersom den ansatte kan jobbe natt, og 0 hvis ikke.`;
    },
);

translations.set(
    'NightShiftMaxSeqLowerThanNightShiftMinSeq',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const min = err.data[1];
        const max = err.data[2];
        return `Ansatt ${employee} - Ansattes minimumssekvens av nattevakt (${min}) er høyere enn hans maksimale 
    sekvens av nattevakt (${max}). Sett 'Min. nattevakter på rad' til et lavere tall enn 'Maks nattevakter på rad', 
    eller 'Maks. nattevakter på rad' til en høyere verdi.`;
    },
);

translations.set(
    'ShiftMaxSeqHasToBeTwoOrThreeIfWorksOnlyWeekend',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - Ansatte som er satt til å kun jobbe helg, må ha 
    'maksimum antall vakter på rad' satt til 2 eller 3 i ansattlisten`;
    },
);

translations.set(
    'DayShiftMaxSeqHasToBeTwoOrThreeIfWorksOnlyWeekend',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - Ansatte som er satt til å jobbe dag og <strong>kun helg</strong>, må ha 
    'Maks. dagvakter på rad' satt til 2 eller 3 i ansattlisten.`;
    },
);

translations.set(
    'EveningShiftMaxSeqHasToBeTwoOrThreeIfWorksOnlyWeekend',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - Ansatte som er satt til å jobbe kveld og <strong>kun helg</strong>, må ha 
    'Maks. kveldsvakter på rad' satt til 2 eller 3 i ansattlisten.`;
    },
);

translations.set(
    'LongShiftMaxSeqHasToBeTwoOrThreeIfWorksOnlyWeekend',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - Ansatte som er satt til å jobbe langvakter/mellomvakter og <strong>kun helg</strong>, 
    må ha 'Maks. langvakter/mellomvakter på rad' satt til 2 eller 3 i ansattlisten.`;
    },
);

translations.set('NightShiftMinSeqHigherThanFive', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} - Ansatte kan ikke jobbe mer enn fire nattevakter på rad. 
        Sett 'minimum antall nattevakter på rad' til 4 eller lavere i ansattlisten.`;
});

translations.set(
    'EmployeeWeekendDaySegmentsMinSeqHigherThanWeekendMaxSeq',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - 'Maks. antall vakter på rad rundt helg' er satt til høyere alle minimumssekvenser 
    av vakter. Vennligst korriger denne eller en av følgende; 'Min. dagvakter på rad', 'Min. kveldsvakter på rad', 
    Min. nattevakter på rad', 'Min. langvakter på rad'`;
    },
);

translations.set(
    'WeekendShiftMaxSequenceLessThanThree',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} kan ikke ha 'Maks. antall vakter på rad rundt helg' mindre enn 3. 
    Sett maks antall vakter på rad rundt helg til 3 eller mer i ansattlisten`;
    },
);

translations.set(
    'WeekendersMinSequenceHigherThanFour',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const day_segment = err.data[1];
        return `Ansatt ${employee} - Ansatte som jobber helg, kan ikke ha 'minimum 
    ${day_segment} på rad' satt til høyere enn 4. Endre i ansattlisten.`;
    },
);

translations.set(
    'WeekendShiftMaxSequenceHigherThanShiftMaxSequence',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - 'Maks. antall vakter på rad rundt helg' kan ikke være høyere enn 
    'Maks. antall vakter på rad'. Vennligst endre en av dem.`;
    },
);

translations.set('SundaysMaxSequenceOneToThree', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} har 'Maks. antall søndager på rad' satt til en ugyldig verdi. 
    Vennligst korriger og sett verdien til enten 1 eller 2.`;
});

translations.set('RedDaysMaxSequenceOutOfBounds', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} må kunne jobbe minimum 1 (og maksimum 5) røde dager på rad. 
    Endre innstillinger i ansattlisten`;
});

translations.set('MovableHolidaysOutOfBoundary', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} må kunne jobbe minimum 1 (og maksimum 10) helligdager i løpet av en hel turnusperiode. 
    Endre innstillinger i ansattlisten`;
});

translations.set(
    'Warning::NightShiftMaxSeqHasToBeThreeIfWeekenderAndWorksNight',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - er satt til å arbeide natt og helg. 'Maks nattevakter på rad' 
    bør settes til 3 eller mer i ansatt innstillingene. Innstillingene som er satt vil føre til at 
    den ansatte ikke får nattevakter i helgene.`;
    },
);

// Availability
translations.set(
    'Warning::OnlyWeekenderRequiresWorkingWeekend',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `${employee} er registrert med «Kun helgearbeid». Vennligst legg til et helgemønster.`;
    },
);

translations.set(
    'EmployeeWorkPatternExceedsWeekendShiftMaxSequence',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const week = err.data[1];
        const year = err.data[2];
        return `Ansatt ${employee} - Den ansatte er satt opp til å jobbe en sekvens av 
    dager (i uke ${week} ${year}) som overgår den maksimale sekvensen. 
    Vennligst juster 'Maks. antall vakter på rad rundt helg' eller begrens arbeidsdager 
    i helgeplanlegger/helligdagsplanlegger.`;
    },
);

translations.set(
    'EmployeeWorkPatternExceedsShiftMaxSequence',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const day = err.data[1];
        return `Ansatt ${employee} - Den ansatte er satt opp til å jobbe en sekvens av dager (${day}) 
    som overgår den maksimale sekvensen. Vennligst juster 'Maks. antall vakter på rad' 
    eller begrens arbeidsdager i helgeplanlegger/helligdagsplanlegger.`;
    },
);

translations.set(
    'EmployeeWorkPatternExceedsDSMaxSequence',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const day = err.data[1];
        const day_segment = err.data[2];
        return `Ansatt ${employee} er satt opp til å jobbe en sekvens av dager (starter ${day}) 
    som overskrider maks vakter (av typen ${day_segment}) på rad. 
    Vennligst sjekk ansatt-innstillingene.`;
    },
);

translations.set('WorkOnWeekendOutsideWeekendPattern', (err: DynomiteError) => {
    const intro = err.data[0];
    const employee = err.data[1];
    const date = err.data[2];
    return `Ansatt ${employee} har satt opp til å arbeide ${date} i ${intro}. 
    Dette må gjøres i helgeplanlegger. Vennligst korriger.`;
});

translations.set('WorksOnlyWeekendHasWeekdayDays', (err: DynomiteError) => {
    const intro = err.data[0];
    const employee = err.data[1];
    const date = err.data[2];
    return `Ansatt ${employee}, som kun jobber helg, er satt opp til  å jobbe en ukedag (${date}) i ${intro}. Vennligst korriger.`;
});

translations.set(
    'EmployeeWorkPatternUnfulfilledDSMinSequence',
    (err: DynomiteError) => {
        const intro = err.data[0];
        const employee = err.data[1];
        const date = err.data[2];
        const day_segment = err.data[3];
        return `Feil i ${intro}: Ansatt ${employee} er satt opp til å jobbe en sekvens av dager (starter ${date}), 
    men vakt -og arbeidsmulighetene gjør at minimumssekvens (av typen ${day_segment}) ikke kan tilfredsstilles.`;
    },
);

translations.set(
    'EmployeeWorkAfterFinishedNightShiftSequence',
    (err: DynomiteError) => {
        const intro = err.data[0];
        const employee = err.data[1];
        const date = err.data[2];
        return `Feil i ${intro}. Ansatt ${employee} er satt opp til å jobbe natt før ${date},
    men det er ikke tilgjengelige nattevaktskoder  denne dagen. Det er ikke lov å jobbe D, A, L dagen etter nattevakt.`;
    },
);

translations.set('EmployeeWorkBlockedByMask', (err: DynomiteError) => {
    const intro = err.data[0];
    const employee = err.data[1];
    const date = err.data[2];
    const day_segment = err.data[3];
    return `Feil i ${intro}. Ansatt ${employee} er satt opp til å jobbe ${date}, 
    men det finnes ikke tilgjengelig vaktkoder av typen ${day_segment} i bemanningsplanen som den ansatte kan jobbe. 
    Vennligst legg til vaktkoder.`;
});

translations.set(
    'EmployeeWorkBlockedByMaskOrProcessing',
    (err: DynomiteError) => {
        const intro = err.data[0];
        const employee = err.data[1];
        const date = err.data[2];
        const dss = err.data[3];
        return `Feil i ${intro}: Ansatt ${employee} er satt opp til å jobbe ${date}, 
    men vakt -og arbeidsmulighetene gjør at den ansatte ikke kan jobbe denne dagen. 
    Vennligst sjekk helgeplanlegger, helligdagsplanlegger, annet fravær og minimum -og 
    makssekvenser av vaktkategorier ${dss}.`;
    },
);

translations.set(
    'EmployeeHasVorPAfterFinishedNightShiftSequence',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const date = err.data[1];
        return `Ansatt ${employee} har satt opp ferie/permisjon dagen etter planlagt nattevakt (${date}). 
    Vennligst korriger i en av planleggerne (ferie, helg, permisjon)`;
    },
);

translations.set(
    'EmployeeWorkDLorNAfterAfterNightSequence',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const date = err.data[1];
        return `Ansatt ${employee} er satt opp til å jobbe en sekvens av nattevakter som ender ${date}. I tillegg 
    er han/hun satt opp til å jobbe enten dagvakt eller nattevakt to dager etter. Vennligst fjern 
    sistnevnte planlagte arbeidsdag. Dette gjøres i en av planleggerne.`;
    },
);

translations.set(
    'EmployeeHasToWorkOnMoreQuickReturnsOnWeekdays',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const iso_week = err.data[1];
        const year = err.data[2];
        return `Ansatt ${employee} er satt opp til å jobbe for mange sein-tidlig vakter i 
    ukedager (uke ${iso_week} ${year}). Vennligst juster opp 'Maks. antall sein-tidlig vakter på 
    ukedager' eller fjern planlagte vakter.`;
    },
);

translations.set(
    'EmployeeHasToWorkOnMoreQuickReturnsOnWeekend',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const iso_week = err.data[1];
        const year = err.data[2];
        return `Ansatt ${employee} er satt opp til å jobbe for mange sein-tidlig vakter i helg (uke ${iso_week} ${year}). 
    Vennligst juster opp  'Maks. antall sein-tidlig vakter i helgen' eller fjern planlagte vakter.`;
    },
);

translations.set('EmployeeWorkPatternNoSpaceForF1', (err: DynomiteError) => {
    const employee = err.data[0];
    const week = err.data[1];
    const year = err.data[2];
    return `Ansatt ${employee} - Den ansatte er satt opp til å jobbe en kombinasjon av helg og 
    ukedager (Uke ${week} ${year}) som gjør at det ikke finnes noen ledige dager for F1. 
    Vennligst juster i enten helgeplanlegger eller helligdagsplanlegger.`;
});

translations.set('EmployeeWorkPatternNoSpaceForF2', (err: DynomiteError) => {
    const employee = err.data[0];
    const week = err.data[1];
    const year = err.data[2];
    return `Ansatt ${employee} - Den ansatte er satt opp til å  jobbe en kombinasjon av helg og 
    ukedager (Uke ${week} ${year}) som gjør at det ikke finnes noen ledige dager for F2. 
    Vennligst juster i enten helgeplanlegger eller helligdagsplanlegger.`;
});

translations.set(
    'EmployeeWorkPatternNoSpaceForF1AndF2',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const week = err.data[1];
        const year = err.data[2];
        return `Ansatt ${employee} - Den ansatte er satt opp til å jobbe en kombinasjon av helg og 
    ukedager (Uke ${week} ${year}) som gjør at det ikke finnes noen ledige dager for F1 og F2. 
    Vennligst juster i enten helgeplanlegger eller helligdagsplanlegger.`;
    },
);

translations.set(
    'EmployeeWeekendPatternsExceedsSundayMaxSequence',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const day = err.data[1];
        const limit = err.data[2];
        return `Ansatt ${employee} har 'maks antall søndager på rad' satt til ${limit} men er satt opp til 
    å jobbe flere helger (${day}) enn dette på rad. Vennligst korriger.`;
    },
);

translations.set(
    'Warning::EmployeeWorksMoreRedDaysInSeqThanMax',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} er satt opp til å jobbe flere røde dager på rad enn spesifisert i 
    'Maks. antall røde dager på rad'. Vennligst korriger.`;
    },
);

// Organization
translations.set('EmplWithEmplOrgIdNotInOrganization', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} ikke tilhører organisasjonen`;
});

translations.set(
    'OrgEmployeeNotInEmployees',
    (_: DynomiteError) =>
        `Organisasjonens ansatte er ikke inkludert i ansattlisten`,
);

translations.set(
    'SharedConfigOrgsDoNotHaveSameValues',
    (_: DynomiteError) => `SharedConfigOrgsDoNotHaveSameValues`,
);
translations.set(
    'SharedOrgEmployeesInOrgsAreNotSame',
    (_: DynomiteError) => `SharedOrgEmployeesInOrgsAreNotSame`,
);

translations.set(
    'NoSharedEmployees',
    (_: DynomiteError) =>
        `Det er ikke tillat å generere flere bemanningsplaner sammen, uten avhengigheter til hverandre`,
);

translations.set(
    'NonCommonPeriod',
    (_: DynomiteError) =>
        `Bemanningsplaner som kjører sammen, må ha lik startdato og antall uker`,
);

translations.set(
    'SharedEmplVacancyRateOverHundredPerCent',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} - Ansatte som jobber i flere avdelinger kan ikke jobbe mer enn 
    100% til sammen`;
    },
);

translations.set(
    'SharedEmployeeHasIntersectingWorkingPatterns',
    (err: DynomiteError) => {
        const employees = err.data[0];
        const day = err.data[1];
        return `Ansatte ${employees} som er linket sammen, er satt opp til å jobbe i flere avdelinger 
    på samme dag (${day}). Vennligst korriger.`;
    },
);

// Config

translations.set('Internal', (err: DynomiteError) => `${err.data[0]}`);

translations.set('ShiftTypeCodeDoesNotMatchKey', (err: DynomiteError) => {
    const code = err.data[0];
    return `Intern feil med vaktkode ${code} i bemanningsplanen. Vennligst kontakt kunderservice`;
});

translations.set(
    'EmptyPositions',
    (_: DynomiteError) =>
        `Mangler en eller flere stillinger på ansatte i oppsettet. Dette skyldes en intern feil.`,
);

translations.set('NonExistingPosition', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} har stilling, men denne eksisterer ikke i registeret. 
    Dette skyldes en intern feil.`;
});

translations.set('NonExistingTrait', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} har spesialkompetanse, men denne eksisterer ikke i registeret. 
    Dette skyldes en intern feil.`;
});

translations.set('NonExistingShiftType', (err: DynomiteError) => {
    const employee = err.data[0];
    return `Ansatt ${employee} kan jobbe vaktkode, men denne eksisterer ikke i registeret. Dette skyldes en intern feil.`;
});

translations.set(
    'EmployeeHasNotEnoughOffsetTimeAroundLongVacation',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const before = err.data[1];
        const after = err.data[2];
        return `Ansatt ${employee} har ferie fra ${before} til ${after}, men det er ikke nok 
    hviletid (minimum 16 timer) mellom vaktene før og etter ferie. Vennligst fjern en vakt.`;
    },
);

translations.set(
    'RestMinOutsideRange',
    (_: DynomiteError) =>
        `Antall timer mellom to vakter må være mellom 8 og 11.`,
);

translations.set(
    'RestMinsNonQuarterHours',
    (_: DynomiteError) =>
        `Minuttene i 'Antall timer mellom to vakter' må være 00, 15, 30 eller 45.`,
);

translations.set(
    'EmployeeHasNotEnoughRestBetweenWorkingShifts',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const date = err.data[1];
        return `Ansatt ${employee} er satt opp til å jobbe ${date}, men det er ikke tilstrekkelig hviletid frem til neste 
    vakt. Vennligst juster opp 'Antall timer mellom to vakter' eller fjern planlagt vakt for den ansatte.`;
    },
);

translations.set(
    'EmployeeHasNoRestCompensationBetweenLongWorkingShifts',
    (err: DynomiteError) => {
        const employee = err.data[0];
        return `Ansatt ${employee} er satt opp til å jobbe {date} med mindre enn 11 timer hviletid, men det er ikke 
    tilstrekkelig kompenserende hviletid frem til neste vakt. Vennligst fjern planlagt vakt for den ansatte.`;
    },
);

translations.set(
    'MaxWorkingMinsRollingPeriodOutsideTheRange',
    (_: DynomiteError) =>
        `Maks antall arbeidstimer over 7 sammenhengende dager må være mellom 48 og 54.`,
);

translations.set('EmployeeWorkCrossRollingMins', (err: DynomiteError) => {
    const employee = err.data[0];
    const start_date = err.data[1];
    const rolling = err.data[2];
    return `Ansatt ${employee} er fra ${start_date} satt opp til å jobbe ${rolling} timer. Vennligst juster slik at 
    den ansatte ikke jobber mer enn 'Maks antall arbeidstimer over 7 sammenhengende dager'.`;
});

translations.set(
    'FOneRestMinsOutsideTheRange',
    (_: DynomiteError) =>
        `Minimum antall (arbeids)timer fri rundt F1 må være mellom 27 og 49 timer.`,
);

translations.set(
    'EmployeesWorkingShiftsWithNotEnoughF1Rest',
    (err: DynomiteError) => {
        const employee = err.data[0];
        const week = err.data[1];
        const year = err.data[2];
        return `Ansatt ${employee} har ikke nok muligheter for F1 dag i uke ${week} ${year}. Vennligst juster planlagte 
    arbeidsdager i planleggerne eller juster ned 'Minimum antall (arbeids)timer fri rundt F1'.`;
    },
);

translations.set(
    'FThreeWorkMinsOutsideTheRange',
    (_: DynomiteError) =>
        `Helgedagsfri i timer må være 0.0, 7.0, 7.1, 7.5 eller 8.0.`,
);

translations.set(
    'MaxEmployeeCountMustBeHigherThanMin',
    (err: DynomiteError) => {
        const shift_code = err.data[0];
        const date = err.data[1];
        const max = err.data[2];
        const min = err.data[3];
        return `Dato ${date}, vaktkode ${shift_code} - 'Maksimum antall ansatte' (${max}) kan 
        ikke være mindre enn 'Minimum antall ansatte' (${min}). Endre i bemanningsplanen`;
    },
);

translations.set(
    'Warning::NotEnoughEmployeesForShiftType',
    (err: DynomiteError) => {
        const date = err.data[0];
        const shift_code = err.data[1];
        const shift_count = err.data[2];
        const empl_count = err.data[3];
        return `Det finnes ikke nok ansatte for vakt <strong> ${shift_code}</strong> på dag <strong>${date}</strong> 
    (minimum ${shift_count} men ${empl_count} er tilgjengelig).`;
    },
);

translations.set('Warning::NotEnoughEmployeesForDay', (err: DynomiteError) => {
    const date = err.data[0];
    const need_count = err.data[1];
    const available_count = err.data[2];
    return `Det er ikke nok ansatte til å dekke dagsarbeid <strong>${date}</strong> (${need_count} krevd, 
    ${available_count} tilgjengelig). Legg til flere ansatte på arbeiddag. Dersom turnus genereres uten å korrigere vil 
    dette gi avvik på bemanning for helg som vises i avviksrapporten.`;
});

translations.set(
    'Warning::NotEnoughEmployeesForShiftPosition',
    (err: DynomiteError) => {
        const position_name = err.data[0];
        const date = err.data[1];
        const shift_code = err.data[2];
        const pos_count = err.data[3];
        return `Det kreves for mange ansatte av typen ${position_name} på dag ${date} og vakt ${shift_code}. Det er 
    bare ${pos_count} tilgjengelige ansatte med denne typen.`;
    },
);

translations.set(
    'Warning::NotEnoughEmployeesForShiftTrait',
    (err: DynomiteError) => {
        const trait_name = err.data[0];
        const date = err.data[1];
        const shift_code = err.data[2];
        const trait_count = err.data[3];
        return `Det kreves for mange ansatte med kompetanse ${trait_name} på dag ${date} og vakt ${shift_code}. 
    Det er bare ${trait_count} tilgjengelige ansatte med denne kompetansen.`;
    },
);

translations.set('tmp', (err: DynomiteError) => {
    const tmp = err.data[0];
    return `${tmp}`;
});

export const getValidationMessage = (err: DynomiteError): string => {
    const translator = translations.get(err.tag);
    if (!translator) {
        return `<i>Melding ikke tilgjengelig (${err.tag})</i>`;
    }

    return translator(err);
};
